import { useEffect, useState, useMemo } from "react";
import axios from "axios";

const getScriptUrl = `${process.env.REACT_APP_API_URL}api/get-script`;

const ScripsDropDownCell = ({
  setValue,
  scriptData,
  setSelectedScriptName,
  className,
}) => {
  const [searchText, setSearchText] = useState("");
  const [scriptList, setScriptList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [hideNBlock, setHideNBlock] = useState("hidden");

  // parse session filter once on mount
  const sessionFilter = useMemo(() => {
    const raw = sessionStorage.getItem("ca_master_scrip");
    return raw ? JSON.parse(raw) : null;
  }, []);

  // fetch scripts and initialize selection once
  useEffect(() => {
    const fetchAndInit = async () => {
      try {
        const res = await axios.get(getScriptUrl);
        setScriptList(res.data.data || []);
      } catch (err) {
      }

      if (sessionFilter) {
        const { scrip_id, scrip_name } = sessionFilter;
        setSearchText(scrip_name);
        setSelectedScriptName(scrip_name);
        setValue((prev) => ({
          ...prev,
          script_id: scrip_id,
        }));
        setHideNBlock("hidden");
      }
    };

    fetchAndInit();
  }, [setValue, setSelectedScriptName, sessionFilter]);

  // whenever searchText or scriptList changes, update the filtered list
  useEffect(() => {
    if (searchText && searchText !== "") {
      setFilteredData(
        scriptList.filter((item) => item.script_name.startsWith(searchText)),
      );
    } else {
      setFilteredData(scriptList);
    }
  }, [searchText, scriptList]);

  const handleOnChange = (e) => {
    const uppercaseValue = e.target.value.toUpperCase();
    uppercaseValue.length === 0
      ? setHideNBlock("hidden")
      : setHideNBlock("block");
    if (uppercaseValue.length === 0) {
      sessionStorage.removeItem("ca_master_scrip");
      setValue((prev) => ({
        ...prev,
        script_id: null,
      }));
      setSelectedScriptName(null);
    }
    setSearchText(e.target.value.toUpperCase());
  };

  const handleSelect = (id, name) => {
    setValue((prev) => ({ ...prev, script_id: id }));
    setSelectedScriptName(name);
    setSearchText(name);
    sessionStorage.setItem(
      "ca_master_scrip",
      JSON.stringify({ scrip_id: id, scrip_name: name }),
    );
    setHideNBlock("hidden");
  };

  return (
    <>
      <div
        className={` ${
          className ? className : "w-[300px]"
        } flex flex-col rounded-[4px] bg-[#F7F7F7]`}
      >
        <div className=" rounded bg-transparent px-2 py-[1px]">
          <input
            value={searchText}
            placeholder={`Search...`}
            className="w-full bg-transparent py-[6px] text-[14px] text-[#382525] focus:outline-none"
            onChange={handleOnChange}
          />
        </div>
      </div>
      <div
        className={`${
          searchText === "" ? "hidden" : "block"
        } absolute z-[999] mt-[77px]  max-h-[680px] overflow-hidden overflow-y-auto`}
      >
        {filteredData.map((item) => (
          <div
            key={item.id}
            onClick={() => handleSelect(item.id, item.script_name)}
            className={`cursor-pointer rounded-[4px] border-b-2 bg-[#D9D9D9] p-[4px] text-[#000] ${hideNBlock}`}
          >
            {item.script_name}
          </div>
        ))}
      </div>
    </>
  );
};

export default ScripsDropDownCell;
